import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Map } from 'immutable';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  retrieveSets,
  cancelAllRequests,
  createSet,
  deleteSet,
  editSet,
  highlightsSetSelected,
  clearPanelTreeList,
} from '../../actions/sets';
import { retrieveBaseSearch, retrieveHighlightSet} from '../../actions/umoGallery';
import { selectWorkspace } from '../../actions/workspacePreview';
import { toggleWorkspacePreview } from '../../actions/mainUI';
import { addError } from '../../actions/messageDialog';
import WorkspaceDialog from '../WorkspaceDialog';
import PanelTree from '../PanelTree';
import { stringifiedToDraggable } from '../../utils/draggables';
import { validateSessionConnection } from '../../actions/session';
import { moveUmoHandler } from '../../utils/umoUtils';
import {isWorkbench} from "../../utils/piction";

const mapStateToProps = state => ({
  sets: state.sets,
  umoGallery: state.umoGallery,
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
  onSetClick: (workspaceID, label, description) => {
    dispatch(highlightsSetSelected(workspaceID));
    dispatch(retrieveHighlightSet(workspaceID, label, description));
  },
  onEditSubmit: (workspaceID, workspaceName, workspaceDescription) =>
    dispatch(editSet(workspaceID, workspaceName, workspaceDescription)),
  onCreateSubmit: (workspaceParentID, workspaceName, workspaceDescription) =>
    dispatch(createSet(workspaceName, workspaceParentID, workspaceDescription)),
  retrieveSets: () => dispatch(retrieveSets()),
  clearPanelTreeList: categoryID => dispatch(clearPanelTreeList(categoryID)),
  onDeleteSubmit: (workspaceID) => {
    dispatch(deleteSet(workspaceID));
    dispatch(selectWorkspace(null, null, null, null));
    dispatch(toggleWorkspacePreview(false));
    dispatch(retrieveBaseSearch());
  },
  cancelAllRequests: () => dispatch(cancelAllRequests()),
  selectWorkspace: (
    { workspaceID, workspaceName, workspaceDescription }
  ) => {
    dispatch(toggleWorkspacePreview(true));
    dispatch(selectWorkspace(workspaceID, workspaceName, workspaceDescription));
  },
  showErrorMessage: (message) => {
    dispatch(addError(message));
  },
  validateSession: surl => dispatch(validateSessionConnection(surl)),
});

class NavSetsPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogToShow: null,
    };

    this.onDialogClose = this.onDialogClose.bind(this);
    this.onSetCreateClick = this.onSetCreateClick.bind(this);
    this.onEditSelect = this.onEditSelect.bind(this);
    this.onPanelItemDrop = this.onPanelItemDrop.bind(this);
    this.renderSetDialog = this.renderSetDialog.bind(this);
  }

  componentDidMount() {
    // this.props.retrieveSets();
    if (this.props.sets.get('setsList').size === 0) this.props.retrieveSets();
  }

  componentWillUnmount() {
    this.props.cancelAllRequests();
  }

  onDialogClose() {
    this.setState({
      dialogToShow: null,
    });
  }

  onEditSelect(key, workspaceID, workspaceName, workspaceDescription){
    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        switch (key) {
          case 'edit':
            this.setState({
              dialogToShow: this.renderSetDialog(true, {
                id: workspaceID,
                name: workspaceName,
                description: workspaceDescription,
              }),
            });
            break;
          default:
            break;
        }
      }
      return null;
    });
  }

  onSetCreateClick(e, workspaceParentID, workspaceName, workspaceDescription) {
    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        const selectedWorkspaceData = workspaceParentID ? {
          id: workspaceParentID,
          name: workspaceName,
          description: workspaceDescription,
        } : null;

        this.setState({ dialogToShow: this.renderSetDialog(false, selectedWorkspaceData) });
      }
    });
    return null;
  }

  onPanelItemDrop(e, workspaceID) {
    e.preventDefault();
    $('.main__search-bar').removeAttr('style');
    const draggable = stringifiedToDraggable(e.dataTransfer.getData('text'));
    if (!(draggable instanceof Error) && workspaceID) {
      const origin = {
        id: draggable.originData.workspaceID,
        isWorkspace: draggable.isWorkspaceItem(),
      };
      const target = {
        id: workspaceID,
        isWorkspace: true,
      };
      moveUmoHandler(origin, target, draggable.getSelectionList(), this.props.dispatch,
        draggable.getIsSelectAll() ? draggable.getSearchParams() : null);
    }
  }

  mouseLeaveHandler() {
    const ev = new MouseEvent('click');
    document.dispatchEvent(ev, true);
  }

  renderSetDialog(isEdit, selectedWorkspaceData) {
    return (<WorkspaceDialog
      onDialogClose={this.onDialogClose}
      selectedWorkspaceData={selectedWorkspaceData}
      isEdit={isEdit}
      editRequests={this.props.sets.get('editRequests')}
      createRequests={this.props.sets.get('createRequests')}
      username={this.props.session.get('username')}
      users={this.props.sets.get('users')}
      onEditSubmit={this.props.onEditSubmit}
      onCreateSubmit={this.props.onCreateSubmit}
      onDeleteSubmit={this.props.onDeleteSubmit}
      isHighlight={true}
    />);
  }

  render() {
    const { intl } = this.props;
    return (
      <div className="nav-content__body nav-highlights" onMouseLeave={this.mouseLeaveHandler}>
        <h2 className="nav-content__title nav-content__title--with-sub">
          {intl.formatMessage({ id: 'navHighlightsPanel.highlightsHeader' })}
        </h2>
        {isWorkbench() ?
        <Button
          onClick={this.onSetCreateClick}
          className="nav-highlights__add-set"
          variant="link"
          size="sm"
        >
          <i className="nav-workspace__add-workspace-icon" aria-hidden="true" />&nbsp;
          {intl.formatMessage({ id: 'navHighlightsPanel.addSetButton' })}
        </Button> : null}
        <PanelTree
          onPanelItemClick={this.props.onSetClick}
          onPanelItemDrop={this.onPanelItemDrop}
          retrievePanelTreeList={this.props.retrieveWorkspaces}
          clearPanelTreeList={this.props.clearPanelTreeList}
          panelTreeList={this.props.sets.get('setsList')}
          onEditSelect={this.onEditSelect}
          editOptions={[
            { eventKey: 'edit', label: intl.formatMessage({ id: 'navHighlightsPanel.menuEditChild' }) },
          ]}
          editRequests={this.props.sets.get('editRequests')}
          customIcons={null}
          isRoot
          isRetrievingRoot={this.props.sets.get('isRetrievingRoot')}
        />
        {this.state.dialogToShow}
      </div>
    );
  }
}

NavSetsPanel.propTypes = {
  sets: PropTypes.instanceOf(Map),
  umoGallery: PropTypes.instanceOf(Map),
  session: PropTypes.instanceOf(Map),
  retrieveSets: PropTypes.func,
  clearPanelTreeList: PropTypes.func,
  cancelAllRequests: PropTypes.func,
  onSetClick: PropTypes.func,
  onEditSubmit: PropTypes.func,
  onDeleteSubmit: PropTypes.func,
  onCreateSubmit: PropTypes.func,
  selectWorkspace: PropTypes.func,
  validateSession: PropTypes.func,
  dispatch: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(NavSetsPanel));



// WEBPACK FOOTER //
// ./src/js/components/NavSetsPanel/index.jsx